// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"78743905","768":"74ac4d18"}[chunkId] + ".chunk.js";
};